import Orders from "./Orders";
import SingleOrder from "../../../../containers/facility/orderEdit";
import GiftCards from "./GiftCards";
import RainChecks from "./RainChecks";
import OrderForms from "./OrderForms";
import Refund from "../../../../containers/facility/orderRefund";
import GiftCard from "./GiftCard";
import RainCheck from "containers/facility/rainCheck";
import OrderForm from "./OrderForm";
import Invoices from "./invoices/Invoices";
import InvoiceNew from "./invoices/InvoiceNew";
import InvoiceEdit from "./invoices/InvoiceEdit";
import Invoice from "./invoices/Invoice";
import Deposits from "./invoices/Deposits";

import FoodOrderingSettings from "./foodOrdering/FoodOrderingSettings";
import FoodOrderingCategories from "./foodOrdering/FoodOrderingCategories";
import NewFoodOrderingCategory from "./foodOrdering/NewFoodOrderingCategory";
import EditFoodOrderingCategory from "./foodOrdering/EditFoodOrderingCategory";
import FoodOrderChitMenu from "../foodOrder/FoodOrderChitMenu";
import ExchangeItems from "./exchangeItems/ExchangeItems";

const orderRoutes: { path: string; component: any }[] = [
  // Orders
  {
    path: "/admin/orderMenu",
    component: Orders,
  },
  {
    path: "/admin/order",
    component: Orders,
  },
  {
    path: "/admin/order/:orderId",
    component: SingleOrder,
  },
  {
    path: "/admin/order/:orderId/refund",
    component: Refund,
  },
  {
    path: "/admin/order/:orderId/exchange",
    component: ExchangeItems,
  },

  //Gift Cards

  {
    path: "/admin/giftcards",
    component: GiftCards,
  },

  {
    path: "/admin/giftcards/:giftCardCode",
    component: GiftCard,
  },

  //Rain Checks
  {
    path: "/admin/rainchecks",
    component: RainChecks,
  },
  {
    path: "/admin/rainchecks/:rainCheckId",
    component: RainCheck,
  },
  {
    path: "/admin/forms",
    component: OrderForms,
  },
  {
    path: "/admin/forms/:orderFormId",
    component: OrderForm,
  },

  // Invoices
  {
    path: "/admin/invoices",
    component: Invoices,
  },
  {
    path: "/admin/invoices/new",
    component: InvoiceNew,
  },
  {
    path: "/admin/invoices/deposits",
    component: Deposits,
  },
  {
    path: "/admin/invoices/:id/edit",
    component: InvoiceEdit,
  },
  {
    path: "/admin/invoices/:id",
    component: Invoice,
  },

  // Food Ordering
  {
    path: "/admin/food-ordering/overview",
    component: FoodOrderingSettings,
  },
  {
    path: "/admin/food-ordering/categories",
    component: FoodOrderingCategories,
  },
  {
    path: "/admin/food-ordering/categories/new",
    component: NewFoodOrderingCategory,
  },
  {
    path: "/admin/food-ordering/categories/:id",
    component: EditFoodOrderingCategory,
  },
  {
    path: "/admin/food-ordering/display",
    component: FoodOrderChitMenu,
  },
];

export default orderRoutes;
